// extracted by mini-css-extract-plugin
export default {"container":"brand-global-nav-sidebar-SideBarSettingsLinks__container--Mrsc7"};